function getCookie(name) {
  let cookieArray = document.cookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    let cookiePair = cookieArray[i].split("=");
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

if (
  $.cookie("delivery_expires_time") === undefined &&
  localStorage.getItem("activeDelivery") === "true"
) {
  localStorage.setItem("activeDelivery", "false");
}

// Check if delivery is set
let isDeliverySet = localStorage.getItem("activeDelivery");
let decideDeliveryLater = $.cookie("delivery_later");

let hasDeliveryPass = window.siteWideSettings.hasDeliveryPass;
let hasXmasTree;
let xmasTreeSkus = ['78291', '9444'];
let activeInCart = [];
let isCartTemplate;
if (document.body.classList.contains("template-cart")) {
  isCartTemplate = true;
  if (!isDeliverySet || isDeliverySet == null) {
    document.querySelector(".delivery-updating").textContent = "Please reserve a delivery slot or pickup store.";
  }
}

// Shipping and minimum order amounts
function setFreeShippingThreshold() {
  console.log("hasDeliveryPass before setting threshold:", hasDeliveryPass);

  let freeShippingThreshold = hasDeliveryPass ? 12000 : 25000;
  console.log("freeShippingThreshold:", freeShippingThreshold);
  return freeShippingThreshold;
}

let minimumOrderAmount = 5000;
if(window.siteWideSettings.no_min_spend == true) {
  minimumOrderAmount = 0;
}

let deliveryPrice;
let liquorInCart;
let deliveryPassInCart = false;
let cartLineCount;

// Shopify account variables
const cid = window.siteWideSettings.cid;
const shopifySID = window.siteWideSettings.shopifySID;

(function (window, document) {
  "use strict";
  var AgileCart = function (options) {
    var defaults = {
      // Defaults configuration
      cartTrigger: ".js-go-cart-trigger",
      cartHeaderTotal: ".header-cart__total",
      cartDrawer: ".js-go-cart-drawer",
      cartDrawerContent: ".js-go-cart-drawer-content",
      cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
      cartDrawerFooter: ".js-go-cart-drawer-footer",
      cartDrawerClose: ".js-go-cart-drawer-close",
      cartRemoveAll: ".cart-drawer__remove-all",
      cartPageContent: ".cart__items--wrapper",
      cartTotalWrapper: ".cart-totals-wrapper",
      cartOverlay: ".js-go-cart-overlay",
      cartCount: ".js-go-cart-counter",
      addToCart: ".js-go-cart-add-to-cart",
      addToCartSearch: ".quick-add__submit-search",
      removeFromCart: ".go-cart-item__remove",
      itemQuantity: ".js-go-cart-quantity",
      itemQuantityPlus: ".js-go-cart-quantity-plus",
      itemQuantityMinus: ".js-go-cart-quantity-minus",
      cartCollection: ".go-cart__collection",
      shippingThresholdTextWrapper: ".threshold__text",
      numberElement: ".cart-shipping__num",
      freeShippingProgress: ".cart-shipping__numOuter",
      cartSuccessMessage: ".cart-shipping__success",
      cartProgressBar: ".cart-shippingThreshold__progress",
      cartShippingWrapper: ".cart-shipping__wrapper",
      cartShippingDisclaimer: ".cart-reserve__wrapper",
      liquorContainer: ".liquor-check-age",
      minSpendWrapper: ".min-cart-spend",
      moneyFormat: "${{amount}}",
    };

    this.settings = Object.assign({}, defaults, options);
    this.init();
    this.bindEvents();
  };

  AgileCart.prototype.init = function () {
    this.cartTrigger = document.querySelector(this.settings.cartTrigger);
    this.cartHeaderTotal = document.querySelector(this.settings.cartHeaderTotal);
    this.cartDrawer = document.querySelector(this.settings.cartDrawer);
    this.cartDrawerContent = document.querySelector(this.settings.cartDrawerContent);
    this.cartDrawerSubTotal = document.querySelector(this.settings.cartDrawerSubTotal);
    this.cartDrawerFooter = document.querySelector(this.settings.cartDrawerFooter);
    this.cartDrawerClose = document.querySelectorAll(this.settings.cartDrawerClose);
    this.cartPageContent = document.querySelector(this.settings.cartPageContent);
    this.cartTotalWrapper = document.querySelector(this.settings.cartTotalWrapper);
    this.cartOverlay = document.querySelector(this.settings.cartOverlay);
    this.cartCount = document.querySelector(this.settings.cartCount);
    this.addToCart = document.querySelector(this.settings.addToCart);
    this.addToCartSearch = document.querySelector(this.settings.addToCartSearch);
    this.removeFromCart = document.querySelector(this.settings.removeFromCart);
    this.itemQuantity = document.querySelector(this.settings.itemQuantity);
    this.itemQuantityPlus = document.querySelector(this.settings.itemQuantityPlus);
    this.itemQuantityMinus = document.querySelector(this.settings.itemQuantityMinus);
    this.cartCollection = document.querySelector(this.settings.cartCollection);
    this.shippingThresholdTextWrapper = document.querySelectorAll(this.settings.shippingThresholdTextWrapper);
    this.numberElement = document.querySelectorAll(this.settings.numberElement);
    this.freeShippingProgress = document.querySelectorAll(this.settings.freeShippingProgress);
    this.cartSuccessMessage = document.querySelector(this.settings.cartSuccessMessage);
    this.cartProgressBar = document.querySelectorAll(this.settings.cartProgressBar);
    this.cartShippingWrapper = document.querySelector(this.settings.cartShippingWrapper);
    this.cartShippingDisclaimer = document.querySelector(this.settings.cartShippingDisclaimer);
    this.minSpendWrapper = document.querySelectorAll(this.settings.minSpendWrapper);
    this.liquorContainer = document.querySelector(this.settings.liquorContainer);
    this.fetchCart();
  };

  AgileCart.prototype.bindEvents = function () {
    var self = this;

    this.cartTrigger.addEventListener("click", function () {
      document.body.classList.add("overflow-hidden");
      self.fetchCart();
      self.openCartOverlay();
    });

    this.cartOverlay.addEventListener("click", function () {
      document.body.classList.remove("overflow-hidden");
      self.closeCartOverlay();
    });

    this.cartDrawerClose.forEach(function (element){
      element.addEventListener("click", function () {
        document.body.classList.remove("overflow-hidden");
        self.closeCartOverlay();
      });
    });

    document.addEventListener("click", function (event) {
      if (event.target.matches(self.settings.cartRemoveAll)) {
        if (confirm("Are you sure?")) {
          self.removeAll();
          if (isCartTemplate) {
            self.cartPageContent.classList.add("updating-cart");
          } else {
            self.cartDrawerContent.classList.add("updating-cart");
          }
          self.renderBlankCartDrawer();
        }
      }
    });

    document.addEventListener(
    "click",
    function (event) {
        var card = event.target.closest(".product-item");
      
        if(card) {
          let productTitle = card.getAttribute("data-title");
          console.log(productTitle)
        }
      
        // Check if the body contains the 'gift-cards' class
        if (document.body.classList.contains('gift-cards')) {
            // Add-to-cart button click handler
            if (event.target.matches('.js-go-cart-add-to-cart.touch-submit')) {
                event.preventDefault(); // Prevent the default action

                // Validate recipient fields
                if (!validateRecipientFields()) {
                    console.log("Validation failed: Please fill out all required fields.");
                    return; // Stop if validation fails
                } else {
                    window.showGiftCardSuccess();
                }
            }
        }

        // Existing add-to-cart logic
        if (event.target.matches(self.settings.addToCart)) {
            event.preventDefault();
          
            if (deliveryPassInCart && productTitle.includes("Delivery Pass")) {
               
                const errorContainer = card.querySelector(".product-error__container");
                if (errorContainer) {
                    errorContainer.innerHTML = "You can only add one Delivery Pass to the cart";
                }
                return; // Stop the function if deliveryPassInCart is true
            }

            if (isDeliverySet === "true" || decideDeliveryLater === "1") {
                let activeProductForms = document.querySelectorAll(".quick-add product-form");
                activeProductForms.forEach(function (form) {
                    form.classList.add("updating-cart");
                });

                if (event.target.matches(".touch-submit")) {
                    if (isCartTemplate) {
                        self.cartPageContent.classList.add("updating-cart");
                    } else {
                        self.cartDrawerContent.classList.add("updating-cart");
                    }

                    let parent = event.target.closest(".quick-add");
                    const quantityContainer = parent.querySelector(".quick-add__quantity");
                    if (quantityContainer) {
                        quantityContainer.style.display = "flex";
                        const input = quantityContainer.querySelector("input");
                        input.value = 1;
                    }
                }

                if (event.target.matches(".quick-add__submit-search")) {
                    var formElement = event.target.closest("product-form");
                    const idInput = formElement.querySelector('input[name="id"]');
                    const wrapperId = idInput.value;
                    self.addItemToCartSearch(wrapperId);
                } else {
                    var formElement = event.target.closest("form");
                    var formId = formElement.getAttribute("id");
                    self.addItemToCart(formId);
                }
            } else {
                const searchModal = document.querySelector(".search-modal");
                if (searchModal) {
                    searchModal.classList.remove("open_modal");
                } else {
                    console.log(".search-modal does not exist at the time this script runs");
                }
                self.closeCartOverlay();
                theme.promptForDeliveryType();
            }
        }
      },
      false
    );
         

    document.addEventListener(
      "click",
      function (event) {
        if (event.target.matches(self.settings.removeFromCart)) {
          if (isCartTemplate) {
            self.cartPageContent.classList.add("updating-cart");
          } else {
            self.cartDrawerContent.classList.add("updating-cart");
          }
          var lineItemElement = event.target.closest(".go-cart-item__single");
          var lineNumber = lineItemElement.getAttribute("data-line");
          self.removeItem(lineNumber);
        }
      },
      false
    );

    document.addEventListener("click", function (event) {
        if (event.target.matches(self.settings.itemQuantityPlus)) {
          if (isDeliverySet === "true" || decideDeliveryLater === "1") {
            var itemElement = event.target.closest(".go-cart-item__single");
            let maxQuantity = parseInt(
              itemElement.querySelector(self.settings.itemQuantity).max
            );
            var line = itemElement.getAttribute("data-line");
            var currentQuantity = parseInt(
              itemElement.querySelector(self.settings.itemQuantity).value,
              10
            );
            if (isNaN(currentQuantity) || currentQuantity < maxQuantity) {
              if (isCartTemplate) {
                self.cartPageContent.classList.add("updating-cart");
              } else {
                self.cartDrawerContent.classList.add("updating-cart");
              }
              self.changeItemQuantity(line, currentQuantity + 1);
            } else {
              console.error("Maximum quantity reached");
              itemElement.querySelector(".product-error__container").innerHTML =
                "Maximum quantity in cart";

              setTimeout(function () {
                itemElement.querySelector(
                  ".product-error__container"
                ).innerHTML = "";
              }, 2000);
            }
          } else {
            self.closeCartOverlay();
            theme.promptForDeliveryType();
          }
        }

        if (event.target.matches(self.settings.itemQuantityMinus)) {
          if (isDeliverySet === "true" || decideDeliveryLater === "1") {
            if (isCartTemplate) {
              self.cartPageContent.classList.add("updating-cart");
            } else {
              self.cartDrawerContent.classList.add("updating-cart");
            }

            var itemElement = event.target.closest(".go-cart-item__single");
            var line = itemElement.getAttribute("data-line");
            var currentQuantity = parseInt(
              itemElement.querySelector(self.settings.itemQuantity).value,
              10
            );
            // Check if currentQuantity is greater than 1
            if (currentQuantity > 1) {
              self.changeItemQuantity(line, currentQuantity - 1);
            } else {
              self.removeItem(line);
            }
          } else {
            self.closeCartOverlay();
            theme.promptForDeliveryType();
          }
        }
      },
      false
    );

    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    document.addEventListener("input", debounce(function (event) {
        if (event.target.matches(".js-go-cart-quantity")) {
          if (isDeliverySet === "true" || decideDeliveryLater === "1") {
            const inputElement = event.target;
            const newValue = inputElement.value.trim();
            var itemElement = inputElement.closest(".go-cart-item__single");
            var id = itemElement.getAttribute("data-id");
            var line = itemElement.getAttribute("data-line"); // Ensure this attribute exists and is correctly populated
            var quantity = parseInt(newValue, 10);
            var maxQuantity = parseInt(inputElement.max, 10) || Infinity; // Use input max or fallback to Infinity

            // Check if the input is a positive integer and does not exceed the max quantity
            if (
              /^\d+$/.test(newValue) &&
              quantity > 0 &&
              quantity <= maxQuantity
            ) {
              if (isCartTemplate) {
                self.cartPageContent.classList.add("updating-cart");
              } else {
                self.cartDrawerContent.classList.add("updating-cart");
              }
              let productUpdates = {};
              // Assuming 'line' is the line item ID and quantity is the new quantity
              productUpdates[id] = quantity;

              // Prepare data in the format expected by the updateItemQuantity method
              var updatesFormatted = Object.keys(productUpdates).map((id) => ({
                id: id,
                quantity: productUpdates[id],
              }));

              console.log(updatesFormatted);
              self.updateItemQuantity(updatesFormatted);
            } else if (quantity === 0) {
              self.removeItem(line);
            } else if (quantity > maxQuantity) {
              // Handle case where quantity exceeds max
              // Option 1: Revert to max quantity
              inputElement.value = maxQuantity;
              let productUpdates = {};

              // Assuming 'line' is the line item ID and quantity is the new quantity
              productUpdates[id] = maxQuantity;

              // Prepare data in the format expected by the updateItemQuantity method
              var updatesFormatted = Object.keys(productUpdates).map((id) => ({
                id: id,
                quantity: productUpdates[id],
              }));

              console.log(updatesFormatted);
              self.updateItemQuantity(updatesFormatted);

              // Option 2: Display an error message (not shown here)
              console.error("Quantity exceeds maximum limit.");
              itemElement.querySelector(".product-error__container").innerHTML =
                "Quantity exceeds maximum limit";

              setTimeout(function () {
                itemElement.querySelector(
                  ".product-error__container"
                ).innerHTML = "";
              }, 2000);
            }
          } else {
            self.closeCartOverlay();
            theme.promptForDeliveryType();
          }
        }
      }, 500)
    );
  };

  (AgileCart.prototype.fetchCart = function (deliveryExpired) {
    console.log("fetchCart");
    
    let activeProductForms = document.querySelectorAll(
      ".quick-add product-form"
    );
    activeProductForms.forEach(function (form) {
      form.classList.remove("updating-cart");
    });

    let self = this;
    let productsInCartArray = [];
    let currentCartValue = 0;
    let cartItemTotal = 0;
    let deliveryId;
    let deliveryPrice;
    let productItems = "";
    let digitalCardQty = 0;
    let alcoholIDs = [];
    let currentRange = null;
    deliveryPassInCart =false;
    window
      .fetch("/cart.js", { credentials: "same-origin", method: "GET" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        productItems = "";
        productItems = document.querySelectorAll(".quick-add__quantity");

        currentCartValue = cart.total_price;
        cartItemTotal = cart.item_count;
        cartLineCount = cart.items.length;
        
        hasXmasTree = false;

        cart.items.forEach((item) => {
          const {
            title: itemTitle,
            variant_id: itemId,
            quantity: itemQuantity,
            price: itemPrice,
            product_type: itemType, // assuming item.product_type is needed for liquor check
            sku: itemSku
          } = item;

          productsInCartArray.push({ id: itemId, quantity: itemQuantity });

          if (itemTitle.toLowerCase().includes("delivery pass")) {
            hasDeliveryPass = true;
            deliveryPassInCart = true;
          }

          if (itemTitle.toLowerCase().includes("delivery fee")) {
            deliveryId = itemId;
            deliveryPrice = itemPrice;
            currentCartValue = currentCartValue - deliveryPrice;
            cartItemTotal = cartItemTotal - 1;
            cartLineCount = cartLineCount - 1;
          }

          if(cartItemTotal == 0 && deliveryId != undefined) {
            self.removeDeliveryFee(deliveryId);
          }

          if (
            itemTitle.toLowerCase().includes("gift card") ||
            itemTitle.toLowerCase().includes("delivery pass")
          ) {
            digitalCardQty += 1;
          }

          if (itemType === "Liquor") {
            liquorInCart = true;
            alcoholIDs.push({ id: itemId, quantity: 0 });
          }

          if (xmasTreeSkus.includes(itemSku)) {
            hasXmasTree = true;
          }
        });

        // After the loop, check if any item had a delivery pass
        let containsDeliveryPass = cart.items.some((item) =>
          item.title.toLowerCase().includes("delivery pass")
        );

        if (digitalCardQty > 0 && digitalCardQty === cartLineCount) {
          localStorage.setItem('digitalProductsOnly', 'true');
        } else {
          localStorage.removeItem('digitalProductsOnly');
        }
        console.log(digitalCardQty + " " + cartItemTotal);
        console.log(localStorage.getItem('digitalProductsOnly'));

        // remove Alcohol for self block and Express 
        if (window.customerAlcoholBlock) {
          if (alcoholIDs.length) {
            self.updateItemQuantity(alcoholIDs);
          }
        }
        console.log(currentCartValue);

        if (deliveryExpired != undefined) {
          if (deliveryId != undefined) {
            console.log(deliveryId, deliveryExpired);
            self.removeDeliveryFee(deliveryId, deliveryExpired);
          }
        }

        if (isCartTemplate) {
          let deliveryRange = self.checkDeliveryRange(currentCartValue);
          console.log('Delivery range: ' + deliveryRange)
          if (deliveryRange === "0-49.99") {
            deliveryPrice = 0;
            if (deliveryId != undefined) {
              self.removeDeliveryFee(deliveryId);
                self.cartTotalWrapper.classList.add("loading-delivery");
            } else {
                self.cartTotalWrapper.classList.remove("loading-delivery");
            }
            document.querySelector(".min-cart-spend").style.display = "flex";
          }

          if (deliveryRange !== currentRange) {
            currentRange = deliveryRange;
            if (currentCartValue > 4999 || window.siteWideSettings.no_min_spend == true) {
              if (isDeliverySet === "true") {
                self.cartTotalWrapper.classList.add("loading-delivery");
                self.runDeliveryCheck(
                  hasDeliveryPass,
                  currentCartValue,
                  deliveryId,
                  deliveryPrice
                );
              } else {
                  console.log("No delivery set");
                  self.cartTotalWrapper.classList.remove("loading-delivery");
              }
            }
          } else {
            self.cartTotalWrapper.classList.remove("loading-delivery");
          }
        }

        self.fetchHandler(cart, cartItemTotal, currentCartValue);

        if (productItems.length > 0) {
          productItems.forEach(function (product) {
            const productId = product.getAttribute("data-id");
            const foundItem = productsInCartArray.find(
              (item) => item.id === parseInt(productId)
            );

            if (foundItem) {
              const quantity = foundItem.quantity;
              product.style.display = "flex";
              product.querySelector("input").textContent = quantity;
              product.querySelector("input").value = parseInt(quantity);
            } else {
              product.style.display = "none";
            }
          });
        }

        if(isCartTemplate) {
          document.querySelector('.cart-header-amount').innerHTML = '$' + currentCartValue / 100;
          if(alcoholIDs.length < 1) {
            hasLiquor = false;
            self.liquorContainer.classList.add('hide-liquor-policy')
            document.querySelector('[name="attributes[contains_liquor]"]').value = 0;
            const digitalID = document.getElementById('digitalid-verify');
            if(digitalID) {
              digitalID.remove();
            }
          } else {
            hasLiquor = true;
            self.liquorContainer.classList.remove('hide-liquor-policy')
            document.querySelector('[name="attributes[contains_liquor]"]').value = 1;
          }
        }

        self.freeShippingCalculator(currentCartValue);
        self.cartHeaderTotal.innerHTML = self.formatMoney(currentCartValue,self.moneyFormat);
        if (cartItemTotal > 0) {
          self.minimumOrderValue(currentCartValue);
        }
      })
      .catch(function (response) {
        console.error("Error while fetching the cart:", response);
      });
  }),
    (AgileCart.prototype.checkDeliveryRange = function (currentCartValue) {
      console.log("checkDeliveryRange");

      if(window.siteWideSettings.no_min_spend == true) {
         return "50-99.99";
      }

      if (currentCartValue >= 0 && currentCartValue < 5000) return "0-49.99";
      if (currentCartValue >= 5000 && currentCartValue < 10000)
        return "50-99.99";
      if (currentCartValue >= 10000 && currentCartValue < 15000)
        return "100-149.99";
      if (currentCartValue >= 15000 && currentCartValue < 20000)
        return "150-199.99";
      if (currentCartValue >= 20000 && currentCartValue < 25000)
        return "200-249.99";
      return "250+"; // Default if it's above all defined ranges
    });

  AgileCart.prototype.runDeliveryCheck = async function (
    hasDeliveryPass,
    currentCartValue,
    deliveryId,
    deliveryPrice
  ) {
    console.log("RunDeliveryCheck");

    let self = this;
    const dayToday = new Date()
      .toLocaleDateString("en-us", { weekday: "long" })
      .toLowerCase();

    if (await self.allProductsAvailable()) {
      if (hasDeliveryPass) {
        console.log(cid);
        if (!cid) {
          console.log("Show login");
          setTimeout(function () {
            document.querySelector(".delivery-updating").innerHTML = `<span class="delivery-pass-warning">Please login to continue to checkout with a Delivery Pass.</span>`;
          }, 550);
          return;
        } else {
          try {
            const data = await fetchJSONP(
              deliveryURL + "delivery-pass-status.php?cid=" + cid,
              "c"
            );
            if (data.status == "SUCCESS" && data.pass_status == "invalid") {
              await self.calculateDelivery(
                deliveryId,
                deliveryPrice,
                currentCartValue
              );
            } else {
              console.log("Delivery pass active");
               await self.calculateDelivery(
                deliveryId,
                deliveryPrice,
                currentCartValue
              );
            }
          } catch (error) {
            console.error("Error with delivery pass status call:", error);
          }
        }
      } else {
        await self.calculateDelivery(
          deliveryId,
          deliveryPrice,
          currentCartValue
        );
      }
    }
  };

  (AgileCart.prototype.calculateDelivery = async function (
    deliveryId,
    deliveryPrice,
    currentCartValue
  ) {
    if(window.siteWideSettings.no_min_spend == true){
      currentCartValue = 5000;
    }
    console.log("calculateDelivery");
    let isDigitalOnly = false;
    if(localStorage.getItem('digitalProductsOnly') == 'true') {
      isDigitalOnly = true;
    }
    console.log(isDigitalOnly);
    
    var self = this;
    try {
      let [customerFrequency, customerGold] = await Promise.all([
        $.ajax({
          type: "GET",
          dataType: "jsonp",
          url:
            deliveryURL +
            "customer-frequency.php?customer_id=" +
            cid +
            "&s=" +
            shopifySID +
            "&c=?",
        }),
        $.ajax({
          type: "GET",
          dataType: "jsonp",
          url:
            deliveryURL +
            "customer-gold.php?customer_id=" +
            cid +
            "&s=" +
            shopifySID +
            "&c=?",
        }),
      ]);

      if (customerFrequency.status === "SUCCESS") {
        isVIP =
          customerFrequency.result === true ||
          customerFrequency.result === "true";
        isFirstThreeOrders =
          customerFrequency.first_three_orders === true ||
          customerFrequency.first_three_orders === "true";
      } else {
        //$("#proceed-to-checkout").hide();
      }

      if (customerGold.status === "SUCCESS") {
        isGold = customerGold.result === true || customerGold.result === "true";
      }

      let deliveryCalculation = await $.ajax({
        type: "GET",
        dataType: "jsonp",
        url: deliveryURL + "calculate-delivery.php?c=?",
        data: {
          delivery_date: $.cookie("delivery_date"),
          delivery_type: $.cookie("delivery_type"),
          delivery_unique_window: $.cookie("delivery_unique_window"),
          customer_id: cid,
          order_total: currentCartValue / 100,
          store: $.cookie("picking_store"),
          postcode: $.cookie("postcode"),
          suburb: $.cookie("suburb"),
          is_vip: isVIP,
          is_gold: isGold,
          first_three_orders: isFirstThreeOrders,
          digital: isDigitalOnly,
          delivery_pass: hasDeliveryPass,
          s: shopifySID,
        },
      });

      let deliveryCost = deliveryCalculation.row.delivery_cost.toFixed(2);
      console.log(deliveryCalculation)
      let grandTotal = deliveryCalculation.row.grand_total.toFixed(2);

      self.deliveryFee(deliveryCost, deliveryCalculation, deliveryId);
      
    } catch (error) {
      console.error("Error in calculateDelivery:", error);
    }
  }),
  (AgileCart.prototype.deliveryFee = function (
      deliveryCost,
      deliveryCalculation,
      deliveryId
    ) {
      console.log("deliveryFee");

      var self = this;
      var deliveryVariant;

      for (let [index, value] of Object.entries(shippingVariants)) {
        var adjustedValue = value / 100;
        if (adjustedValue == deliveryCost) {
          deliveryVariant = index;
          break; // Exit the loop once a match is found
        }
      }

      document.querySelector(".delivery-total").innerHTML =
        deliveryCost === "0.00" ? "FREE" : "$" + deliveryCost;

      var productUpdates = [];
      if (deliveryVariant) {
        if (deliveryVariant == deliveryId) {
          console.log("Correct delivery rate in cart");

          self.cartTotalWrapper.classList.remove("loading-delivery");
        } else if (deliveryId !== deliveryVariant && deliveryId !== undefined) {
          productUpdates.push({ id: deliveryId, quantity: 0 });
          productUpdates.push({ id: deliveryVariant, quantity: 1 });
          self.updateItemQuantity(productUpdates);
        } else {
          productUpdates.push({ id: deliveryVariant, quantity: 1 });
          self.updateItemQuantity(productUpdates);
        }
      } else {
        console.log("No match found");
      }
  }),
  (AgileCart.prototype.formatMoney = function (amount) {
      console.log("formatMoney");
      return this.settings.moneyFormat.replace("{{amount}}", amount);
  });

  (AgileCart.prototype.fetchHandler = function (
    cart,
    cartItemTotal,
    currentCartValue
  ) {
    this.cartItemCount(cartItemTotal);
    if (isCartTemplate) {
      if (cart.item_count === 0) {
        this.renderBlankCartPage();
        this.minSpendWrapper.forEach(function (wrapper) {
          wrapper.style.display = "none";
        });
      } else {
        this.renderCartPage(cart);
      }
    } else {
      if (cart.item_count === 0) {
        this.minSpendWrapper.forEach(function (wrapper) {
          wrapper.style.display = "none";
        });
        this.renderBlankCartDrawer();
      } else {
        this.cartCollection.classList.add("is-invisible");
        this.renderDrawerCart(cart, currentCartValue);
        this.cartDrawerFooter.classList.remove("is-invisible");
      }
    }
  }),
    (AgileCart.prototype.cartItemCount = function (cartItemTotal) {
      this.cartCount.innerHTML = cartItemTotal;
    }),
    AgileCart.prototype.addItemToCart = function (formId) {
      console.log("addItemToCart");
      var self = this,
      formElement = document.querySelector("#" + formId); // Correctly target the form by its ID

      if (!formElement) {
        console.error("Form not found: #" + formId);
        return; // Exit if form not found
      }

     // Create FormData object from the form
     var formData = new FormData(formElement);
     console.log(formData);

     // Convert FormData to URL-encoded string
     var formDataObj = new URLSearchParams();
     formData.forEach(function (value, key) {
       formDataObj.append(key, value);
     });

     console.log(formDataObj.toString());

     window
       .fetch("/cart/add.js", {
         method: "POST",
         credentials: "include",
         headers: { "Content-Type": "application/x-www-form-urlencoded" },
         body: formDataObj.toString(), // Use the URL-encoded string
       })
       .then(function (response) {
         return response.json();
       })
       .then(function (cartResponse) {
         self.fetchCart(); // Handle cart count update
       })
       .catch(function (error) {
         self.ajaxRequestFail(); // Make sure this method is defined to handle request failures
         console.error("Error adding item to cart: ", error);
       });
    };
    (AgileCart.prototype.addItemToCartSearch = function (wrapperId) {
      var self = this;

      // Find the hidden input within the wrapper
      var variantId = wrapperId;
      console.log(variantId);

      if (!variantId) {
        console.error("Variant ID input not found");
        return; // Exit if the variant input is not found
      }

      // Create an object to submit. Adjust the object structure as per your needs.
      var formDataObj = { id: variantId };

      window
        .fetch("/cart/add.js", {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formDataObj), // Use the object directly
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cartResponse) {
          self.fetchCart(); // Handle cart count update
        })
        .catch(function (error) {
          self.ajaxRequestFail(); // Make sure this method is defined to handle request failures
          console.error("Error adding item to cart: ", error);
        });
    });

  (AgileCart.prototype.changeItemQuantity = function (lineNumber, quantity) {
    console.log("changeItemQuantity");
    var self = this;
    window
      .fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({ quantity: quantity, line: lineNumber }),
        headers: { "Content-Type": "application/json" },
      })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        return self.fetchCart();
      })
      .catch(function (error) {
        self.ajaxRequestFail();
        console.error(error);
      });
  }),
    (AgileCart.prototype.updateItemQuantity = function (productUpdates) {
      console.log("updateItemQuantity");
      var self = this;

      const data = {
        updates: {},
      };
      // Loop through each product update and populate the data object
      productUpdates.forEach((update) => {
        const { id, quantity } = update;
        data.updates[id] = quantity;
      });

      // Set up the request options for the Fetch API
      const options = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      // Set up the URL for the Ajax API call
      const apiUrl = "/cart/update.js";

      // Make the API call using the Fetch API
      fetch(apiUrl, options)
        .then((response) => response.json())
        .then((data) => console.log(data))
        .catch((error) => console.error(error))
        .finally(() => {
          self.fetchCart();
        });
    }),
    (AgileCart.prototype.removeItem = function (lineNumber) {
      console.log("removeItem");
      var self = this;
      window
        .fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          body: JSON.stringify({ quantity: 0, line: lineNumber }),
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          return self.fetchCart();
        })
        .catch(function (error) {
          self.ajaxRequestFail();
          console.error(error); // Log the error instead of throwing it
        });
    }),
    (AgileCart.prototype.removeAll = function () {
      console.log("removeAll");
      var self = this;
      window
        .fetch("/cart/clear.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          return self.fetchCart();
        })
        .catch(function (error) {
          self.ajaxRequestFail();
          console.error(error); // Log the error instead of throwing it
        });
    }),
    // Utility methods
    (AgileCart.prototype.openCartOverlay = function () {
      this.settings.cartDrawer.classList.add("is-open");
      this.settings.cartOverlay.classList.add("is-open");
    }),
    (AgileCart.prototype.closeCartOverlay = function () {
      document.body.classList.remove("overflow-hidden");
      this.settings.cartDrawer.classList.remove("is-open");
      this.settings.cartOverlay.classList.remove("is-open");
    }),
    (AgileCart.prototype.renderBlankCartDrawer = function () {
      console.log("renderBlankDrawer");
      this.cartDrawerContent.classList.add("empty-cart");
      this.cartShippingDisclaimer.classList.add("is-invisible");
      this.cartCollection.classList.remove("is-invisible");
      this.cartDrawerFooter.classList.add("is-invisible");
      this.cartDrawerSubTotal.parentNode.classList.add("is-invisible");
      this.cartShippingWrapper.classList.add("is-invisible");
      //this.clearCart();
      this.cartDrawerContent.innerHTML = `
            <div class="go-cart__empty">
               <svg class="icon icon-cart" role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                 <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                 <line x1="3" y1="6" x2="21" y2="6"></line>
                 <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
              Your cart is empty
              <span class="empty-text">Continue shopping to browse and search for items.</span>
              <a href="/collections/online-specials" class="cart-continue button button--primary">Continue Shopping</a>
            </div>
           `;
    }),
    (AgileCart.prototype.renderBlankCartPage = function () {
      console.log("renderBlankPage");
      var cartItems = document.querySelector(".cart__items");
      document.querySelector(".cart-totals-wrapper").style.display = "none";
      if (cartItems) {
        document.querySelector(".cart__items").style.display = "none";
      }
      document.querySelector(".cart__warnings").style.display = "flex";
      this.clearCart();
    }),
    (AgileCart.prototype.renderDrawerCart = function (cart, currentCartValue) {
      var emptyCartElement =
        this.cartDrawerContent.querySelector(".go-cart__empty");

      // Check if the element exists before trying to remove it
      if (emptyCartElement) {
        emptyCartElement.remove();
      }
      this.cartDrawerContent.classList.remove("empty-cart");

      var self = this;
      let totalPriceWithoutDelivery = 0;

      if (isDeliverySet == "true") {
        self.cartShippingWrapper.classList.remove("is-invisible");
        self.cartShippingWrapper.classList.remove("hide-cart-element");
        self.cartShippingDisclaimer.classList.add("hide-cart-element");
        self.cartDrawerContent.classList.remove("delivery-not-set");
      } else {
        self.cartDrawerContent.classList.add("delivery-not-set");
        self.cartShippingWrapper.classList.add("is-invisible");
        self.cartShippingDisclaimer.classList.remove("hide-cart-element");
      }

      console.log("renderDrawerCart");

      // Show the overlay
      // Start simulating progress
      const progressBar = document.querySelector(".progress-bar");
      progressBar.style.width = "0%"; // Reset progress
      setTimeout(() => (progressBar.style.width = "100%"), 100); // Start progress

      fetch("/?section_id=cart-drawer-items", {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
        },
      })
        .then((response) => response.text())
        .then((html) => {
          // Inject the new HTML into the cart drawer
          self.cartDrawerContent.innerHTML = html;

          self.cartDrawerContent.classList.remove("updating-cart");
          progressBar.style.width = "0%"; // Reset progress bar for the next update

          self.cartDrawerSubTotal.innerHTML = self.formatMoney(
            currentCartValue,
            self.moneyFormat
          );
          self.cartDrawerSubTotal.parentNode.classList.remove("is-invisible");
        })
        .catch((error) => console.error("Error updating cart drawer:", error));
    });

  AgileCart.prototype.renderCartPage = function (cart) {
    
    var self = this;
    let updatedCartPrice = 0;
    console.log("renderCartPage");
    var deliverySuburb = $.cookie('suburb'); 
    if (deliverySuburb) {
      // Update the input field if the cookie exists
      $('input[name="attributes[delivery_suburb]"]').val(deliverySuburb);
    }
    deliveryPrice = 0;

    const progressBar = document.querySelector(".progress-bar");
    progressBar.style.width = "0%"; // Reset progress
    setTimeout(() => (progressBar.style.width = "100%"), 100); // Start progress

    fetch("/?section_id=cart-page-items", {
      method: "GET",
      headers: {
        "Content-Type": "text/html",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        // Inject the new HTML into the cart drawer
        self.cartPageContent.innerHTML = html;

        self.cartPageContent.classList.remove("updating-cart");
        progressBar.style.width = "0%"; // Reset progress bar for the next update
        self.updateCartSubtotal();
        self.cartHeaderTotal.innerHTML = self.formatMoney(
          cart.total_price,
          self.moneyFormat
        );
        const liquorAgeCheck = document.querySelector(".liquor-check-age");
        if (hasLiquor) {
          liquorAgeCheck.classList.add("show-liquor-age-check");
        } else {
          liquorAgeCheck.classList.remove("show-liquor-age-check");
        }
      })
      .catch((error) => console.error("Error updating cart drawer:", error));
  };

 AgileCart.prototype.updateCartSubtotal = function () {
  console.log("updateCartSubtotal");
  var self = this;

  fetch("/?section_id=cart-totals")
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const checkoutElement = doc.getElementById("checkout");
      if(isDeliverySet == 'false') {
        checkoutElement.disabled = true;
      }

      // Modify the HTML as needed
      const liquorAgeCheck = document.querySelector(".liquor-check-age");
      if (hasLiquor) {
        liquorAgeCheck.classList.add("show-liquor-age-check");
        const liquorDeliveryAvailable = localStorage.getItem('liquorDeliveryAvailable');
        
        if (window.siteWideSettings.customerVerified) {
          if(isDeliverySet == 'true') {
            if(liquorDeliveryAvailable == 'true') {
              checkoutElement.innerHTML = "Checkout";
              checkoutElement.disabled = false;
            } else {
              checkoutElement.innerHTML = "Checkout";
              checkoutElement.disabled = true;
            }
            
          } else {
            checkoutElement.innerHTML = "Please reserve a time slot";
            checkoutElement.disabled = true;
          }
        } else {
          // Handle unverified customer case
        }
      } else {
        liquorAgeCheck.classList.remove("show-liquor-age-check");
      }

      // Inject the modified HTML into the totals wrapper
      document.querySelector(".totals-wrapper").innerHTML = doc.body.innerHTML;

      // At this point, the HTML has been injected, and you can now select and modify the dynamically inserted element
      const element = document.querySelector('.alcohol-delivery-not-available');
      if (element) {
        if(liquorDeliveryAvailable == 'false' && hasLiquor) {
          element.style.display = 'block';
        }
      }

      // Christmas Trees
      let xmasTreeErrorText = '';      

      if (hasXmasTree) {        
        if ($.cookie('delivery_type') != "CT") {
          xmasTreeErrorText = 'To order a Christmas Tree, please select a "Christmas Trees Only" delivery time under "Delivery" when making your delivery reservation.';
        } else if (cartLineCount > 1) {
          xmasTreeErrorText = 'To order a Christmas Tree, please remove all other items from your cart.';
        }
      } else if ($.cookie('delivery_type') == "CT") {
        // CT is for Christmas Trees Only
        xmasTreeErrorText = 'You have selected a "Christmas Trees Only" delivery time. Please add only a Christmas Tree to your cart to checkout.';
      }

      if (xmasTreeErrorText) {
        const xmasTreeErrorElement = document.querySelector('.xmas-tree-delivery-not-available');        

        if (xmasTreeErrorElement) {      
          xmasTreeErrorElement.innerHTML = xmasTreeErrorText;
          xmasTreeErrorElement.style.display = 'block';
          document.getElementById('checkout').disabled = true;
        }
      }
      // End Christmas Trees

      // Check if the clickCollectSelected flag exists in localStorage
      if (localStorage.getItem("clickCollectSelected") === "true") {
        document.querySelector(".total.total-delivery").style.display = "none";
        document.getElementById("leave_unattended_box").style.display = "none";
      }
    })
    .catch((error) => console.error("Error updating cart subtotal:", error));
};

  AgileCart.prototype.openCartOverlay = function () {
    this.cartDrawer.classList.add("is-open");
    this.cartOverlay.classList.add("is-open");
  };

  AgileCart.prototype.closeCartOverlay = function () {
    this.cartDrawer.classList.remove("is-open");
    this.cartOverlay.classList.remove("is-open");
  };

  AgileCart.prototype.removeItemAnimation = function (element) {
    if (element) element.classList.add("is-invisible");
  };

  AgileCart.prototype.clearCart = function () {
    console.log("clearCart");

    if (isCartTemplate) {
      if (this.cartPageContent) {
        this.cartPageContent.innerHTML = "";
      }
    } else {
      this.cartDrawerContent.innerHTML = "";
    }
  };

  // Free Shipping Calculator
  AgileCart.prototype.freeShippingCalculator = function (currentCartValue) {
    var self = this;
    console.log("freeShippingCalculator");

    // Set the freeShippingThreshold based on hasDeliveryPass
    let freeShippingThreshold = hasDeliveryPass ? 12000 : 25000;
    console.log("freeShippingThreshold:", freeShippingThreshold);

    var percentage;
    var newProgressNum;

    if (currentCartValue < freeShippingThreshold) {
      document.querySelector(".free-shipping-icon").classList.remove("free-shipping-achieved");
      percentage = (currentCartValue / freeShippingThreshold) * 100;
      
      newProgressNum = currentCartValue;

      console.log("Initial newProgressNum:", newProgressNum);

      newProgressNum = (freeShippingThreshold - newProgressNum) / 100;

      console.log("After calculation:", newProgressNum);

      newProgressNum = newProgressNum.toFixed(2);
      console.log("Final newProgressNum:", newProgressNum); 

      self.shippingThresholdTextWrapper.forEach(function (el) {
        el.innerHTML = " for FREE delivery.";
      });

      self.numberElement.forEach(function (el) {
        el.textContent = "$" + newProgressNum;
      });

      self.freeShippingProgress.forEach(function (el) {
        el.style.display = "block";
      });

      self.cartSuccessMessage.style.display = "none";

      self.cartProgressBar.forEach(function (el) {
        el.setAttribute("style", "width:" + percentage + "%");
      });
    } else {
      document.querySelector(".free-shipping-icon").classList.add("free-shipping-achieved");
      newProgressNum = (freeShippingThreshold - currentCartValue) / 100;
      newProgressNum = parseFloat(newProgressNum.toFixed(2));
      percentage = 100;
     
      self.numberElement.forEach(function (el) {
        el.innerHTML = "$" + newProgressNum;
      });

      self.freeShippingProgress.forEach(function (el) {
        el.style.display = "none";
      });

      self.cartSuccessMessage.style.display = "block";

      self.cartProgressBar.forEach(function (el) {
        el.setAttribute("style", "width:100%");
      });
    }
  };

  (AgileCart.prototype.minimumOrderValue = function (currentCartValue) {
    var self = this;
    console.log("minimumOrderValue");

    if (currentCartValue > minimumOrderAmount) {
      self.minSpendWrapper.forEach(function (wrapper) {
        wrapper.style.display = "none";
      });
    } else if (currentCartValue > 0) {
      const amountToSpend = (minimumOrderAmount - currentCartValue) / 100;

      self.minSpendWrapper.forEach(function (wrapper) {
        wrapper.style.display = "block";
        wrapper.innerHTML =
          "<div>" +
          '<span><svg version="1.1" class="icon icon-info" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256C512,114.511,397.504,0,256,0z M256,476.279c-121.462,0-220.279-98.816-220.279-220.279S134.538,35.721,256,35.721S476.279,134.537,476.279,256S377.462,476.279,256,476.279z"/></g></g><g><g><path d="M256.006,213.397c-15.164,0-25.947,6.404-25.947,15.839v128.386c0,8.088,10.783,16.174,25.947,16.174c14.49,0,26.283-8.086,26.283-16.174V229.234C282.289,219.8,270.496,213.397,256.006,213.397z"/></g></g><g><g><path d="M256.006,134.208c-15.501,0-27.631,11.12-27.631,23.925c0,12.806,12.131,24.263,27.631,24.263c15.164,0,27.296-11.457,27.296-24.263C283.302,145.328,271.169,134.208,256.006,134.208z"/></g></g></svg> Spend $' +
          amountToSpend +
          " more to meet the $50 order minimum.</span></div>";
        if (!isCartTemplate) {
          setTimeout(function () {
            wrapper.style.display = "none";
          }, 4000);
        }
      });
    }
  }),
    (AgileCart.prototype.updateCartItems = async function () {
      document.getElementById("pageOverlay").style.display = "flex";
      console.log("updateCartItems");
      let newStoreName = "Store not found";
      let previousStoreName = "Store not found";
      
      let self = this;
      activeInCart = [];

      const pickingStore = getCookie("picking_store");
      const previousPickingStore = localStorage.getItem('currentPickingStore');
      
      if (pickingStore) {
        const storeId = parseInt(pickingStore, 10);
        newStoreName = storeMatrix[0][storeId] || newStoreName;
      }

      if(previousPickingStore) {
        const previousStoreId = parseInt(previousPickingStore, 10);
        previousStoreName = storeMatrix[0][previousStoreId] || previousStoreName;
      }

      console.log(newStoreName + ' ' + previousStoreName)

      
      localStorage.setItem("failedItems", "");
      let unAvailableItems = [];

      document.getElementById("pageOverlay").style.display = "flex";
      if(previousStoreName !== newStoreName) {
       document.querySelector('.store-change-text').innerHTML = previousStoreName + `<svg class="icon icon-arrow" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 466.205 466.205" style="enable-background:new 0 0 466.205 466.205;" xml:space="preserve"><g><g><path d="M416.193,170.894c-0.052-0.053-0.105-0.105-0.158-0.158L253.049,7.536c-1.295-1.288-2.726-2.432-4.267-3.413l-4.693-2.56l-3.2-1.067h-2.347c-3.596-0.661-7.283-0.661-10.88,0h-2.133h-2.56l-3.627,1.92c-2.021,1.098-3.887,2.461-5.547,4.053L50.169,170.736c-10.957,10.87-11.028,28.565-0.158,39.522c0.052,0.053,0.105,0.105,0.158,0.158c11.045,10.538,28.421,10.538,39.467,0l97.493-97.28c4.206-4.124,10.96-4.058,15.084,0.149c1.919,1.957,3.011,4.577,3.049,7.318v317.653c-0.001,15.435,12.51,27.948,27.945,27.949c15.435,0.001,27.947-12.51,27.949-27.945c0-0.001,0-0.003,0-0.004V120.603c0.083-5.89,4.925-10.599,10.815-10.516c2.74,0.039,5.361,1.13,7.318,3.049l97.067,97.28c11.073,10.674,28.607,10.674,39.68,0C426.993,199.546,427.064,181.851,416.193,170.894z"/></g></g></svg>` + newStoreName;
      }
      document.getElementById("overlayText").innerText = "Updating cart items based on picking store change";

      const progressBarFill = document.querySelector(".progress-bar-fill");
      progressBarFill.style.width = "0%"; // Reset progress bar width
      setTimeout(() => (progressBarFill.style.width = "100%"), 100);

      try {
        const cartResponse = await fetch("/cart.js").then((res) => res.json());
        if (cartResponse.items.length === 0) {
          console.log("Cart empty, refresh");
          window.location.reload();
          return;
        }

        await fetch("/cart/clear.js", { method: "POST" });
        const itemPromises = cartResponse.items.map(async (item) => {
          const productData = await fetch(`/products/${item.handle}.js`).then(
            (res) => res.json()
          );
          productData.variants.forEach((variant) => {
            if (pickingStore === variant.option1) {
              if (variant.available) {
                activeInCart.push({ id: variant.id, quantity: item.quantity });
              } else {
                if (productData.title !== "Delivery Fee") {
                  unAvailableItems.push(productData.title);
                }
              }
            }
          });
          if (
            !productData.options[0].values.includes(pickingStore.toString()) &&
            productData.title !== "Delivery Fee"
          ) {
            unAvailableItems.push(productData.title);
          }
        });

        await Promise.all(itemPromises);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        self.addRelevantProductsBack(unAvailableItems);
      } catch (error) {
        console.error(error);
      }
    });

  // If delivery fee active but no delivery slot, remove delivery fee and update stored delivery price to zero.
  AgileCart.prototype.removeDeliveryFee = function (deliveryId) {
    let productUpdates = [];
    if (deliveryId !== undefined) {
      productUpdates.push({ id: deliveryId, quantity: 0 });
      this.updateItemQuantity(productUpdates);
      if(isCartTemplate) {
        this.cartTotalWrapper.classList.remove("loading-delivery");
      }
    } else {
      if (isCartTemplate) {
        this.cartTotalWrapper.classList.remove("loading-delivery");
      }
    }
  };

  AgileCart.prototype.allProductsAvailable = function () {
    var d = new Date();
    var theDeliveryDate = new Date($.cookie("delivery_date"));
    var dayToday = weekday[d.getDay()];
    var dayTomorrow = weekday[d.getDay() + 1];
    var timeOfDay = $("[name='attributes[local_delivery_request]']").val();
    return true;
  };

  (AgileCart.prototype.addRelevantProductsBack = function (unAvailableItems) {
    console.log("addRelevantProductsBack");

    localStorage.setItem("failedItems", JSON.stringify(unAvailableItems)); // Assuming unAvailableItems is an array

    const fetchPromises = [];

    while (activeInCart.length > 0) {
      const data = {
        updates: activeInCart.reduce(
          (acc, { id, quantity }) => ({ ...acc, [id]: quantity }),
          {}
        ),
      };

      activeInCart.splice(0, activeInCart.length);

      const options = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      const apiUrl = `/cart/update.js`;
      fetchPromises.push(
        fetch(apiUrl, options).then((response) => response.json())
      );
    }

    Promise.all(fetchPromises)
      .then((results) => {
        if (unAvailableItems.length > 0) {
          console.log("Unavailable items:", unAvailableItems);
          // Handle UI update or redirection here
        } else {
          console.log("All items updated successfully");
          this.fetchCart();
        }

        document.querySelectorAll(".progress-bar").forEach(function (bar) {
          bar.style.display = "none";
        });

        document.querySelector('.dynamic-store-text').style.flexDirection = 'row';
        document.querySelector('.dynamic-store-text').classList.add('items-updated')
        document.getElementById("overlayText").innerText = "Items updated.";
        document.getElementById("completionTick").style.display = "block";

        // Hide the progress bar
      })
      .catch(console.error)
      .finally(() => {
        window.location.reload();
      });
    }),
    
    (AgileCart.prototype.formatMoney = function (cents, format) {
      console.log();
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || "${{amount}}";

      function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ",",
        decimal = "."
      ) {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    });

  function fetchJSONP(url, callbackParamName) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      const callbackFunctionName = `jsonp_callback_${Math.round(
        100000 * Math.random()
      )}`;

      window[callbackFunctionName] = function (data) {
        delete window[callbackFunctionName];
        document.body.removeChild(script);
        resolve(data);
      };

      // Ensure correct URL formatting
      const separator = url.includes("?") ? "&" : "?";
      script.src = `${url}${separator}${callbackParamName}=${callbackFunctionName}`;
      script.onerror = function () {
        delete window[callbackFunctionName];
        document.body.removeChild(script);
        reject(new Error("Script load error"));
      };
      document.body.appendChild(script);
    });
  }
  // Make sure to implement ajaxRequestFail as needed

  window.AgileCart = AgileCart;
})(window, document);

var agileCart = new AgileCart({});

let freeShippingThreshold = setFreeShippingThreshold();
